/* Elbury — page behaviour: delivery dates, accordions, FAQ nav, reveal, collection filters, product page */
(function () {
  'use strict';
  var d = document;
  var $ = function (s, r) { return (r || d).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); };
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var TINTS = ['#E9E3DA', '#E4DDD2', '#EDE7DE', '#E2DBD0'];
  var HEX = { black: '#1c1a18', brown: '#7A4A2A', 'light brown': '#7A4A2A', 'dark brown': '#4a2c1a', beige: '#C8AE8A', navy: '#22314A', 'navy blue': '#22314A', blue: '#22314A', 'indigo blue': '#22314A', red: '#982A22', 'dark red': '#982A22', burgundy: '#982A22', purple: '#5A3A63', leopard: '#B7884E', white: '#EDE8E0', pink: '#D8A3A6', green: '#3E5A3A', 'army green': '#3E5A3A', 'crocodile green': '#3E5A3A', grey: '#8B8883', gray: '#8B8883', silver: '#8B8883' };
  var PLUS = 'M12 5v14M5 12h14', MINUS = 'M5 12h14';
  function money(c) { return '£' + (c / 100).toFixed(2); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function addWork(dt, n) { var x = new Date(dt); while (n > 0) { x.setDate(x.getDate() + 1); var w = x.getDay(); if (w !== 0 && w !== 6) n--; } return x; }
  function fmtD(dt) { return dt.toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short' }).replace(',', ''); }
  function fmtS(dt) { return dt.toLocaleDateString('en-GB', { day: 'numeric', month: 'short' }); }
  var now = new Date();
  var ETA = { disp: fmtD(addWork(now, 2)), range: fmtS(addWork(now, 8)) + ' – ' + fmtS(addWork(now, 10)) };
  var store = {
    get: function (k) { try { return JSON.parse(localStorage.getItem(k) || 'null'); } catch (e) { return null; } },
    set: function (k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  };
  function matOf(tags) {
    tags = tags || [];
    if (tags.indexOf('Faux Leather Moccasin') >= 0) return 'Faux leather';
    if (tags.indexOf('Patent Moccasin') >= 0) return 'Patent';
    if (tags.indexOf('Suede Moccasin') >= 0) return 'Suede';
    if (tags.indexOf('Leather Moccasin') >= 0) return 'Leather';
    if (tags.indexOf('Canvas Moccasin') >= 0) return 'Canvas';
    return '';
  }
  function cardFromJson(p, i) {
    var col = '';
    (p.options || []).forEach(function (o) { var n = (o.name || '').toLowerCase(); if ((n === 'colour' || n === 'color') && o.values && o.values.length) col = o.values[0]; });
    var mat = matOf(p.tags);
    var cap = p.compare_at_price || 0, sale = cap > p.price;
    var img = p.featured_image ? (p.featured_image.indexOf('//') === 0 ? 'https:' + p.featured_image : p.featured_image) : '';
    if (img) img += (img.indexOf('?') >= 0 ? '&' : '?') + 'width=600';
    return '<a class="eb-card" href="' + esc(p.url) + '"><span class="eb-tile" style="background: ' + TINTS[i % 4] + '">' +
      (img ? '<img src="' + esc(img) + '" alt="' + esc(p.title) + '" loading="lazy">' : '') +
      (sale ? '<span class="eb-badge">Save ' + money(cap - p.price).replace('.00', '') + '</span>' : '') + '</span>' +
      '<span class="eb-ct"><span class="eb-t">' + esc(p.title) + '</span>' +
      (col ? '<span class="eb-m"><span class="eb-sw" style="background: ' + (HEX[col.toLowerCase()] || '#999') + '"></span>' + esc(col) + (mat ? ' · ' + mat : '') + '</span>' : '') +
      '<span class="eb-p">' + (sale ? '<s>' + money(cap) + '</s>' : '') + '<b>' + money(p.price) + '</b></span></span></a>';
  }
  function simpleCard(p, i) {
    return '<a class="eb-card" href="' + esc(p.u) + '"><span class="eb-tile" style="background: ' + TINTS[i % 4] + '">' +
      (p.i ? '<img src="' + esc(p.i) + '" alt="' + esc(p.t) + '" loading="lazy">' : '') +
      '</span><span class="eb-ct"><span class="eb-t">' + esc(p.t) + '</span><span class="eb-p"><b>' + esc(p.p) + '</b></span></span></a>';
  }
  function lock(on) { d.documentElement.classList.toggle('eb-lock', !!on); }
  function shade() { return $('#eb-layer .eb-shade'); }

  function initCommon() {
    $$('.eb-main [data-eta], .eb-foot [data-eta]').forEach(function (el) { el.textContent = ETA[el.getAttribute('data-eta')] || ''; });

    /* accordions: one open per group */
    $$('[data-eb-acc]').forEach(function (g) {
      g.addEventListener('click', function (e) {
        var h = e.target.closest('.eb-acc-h'); if (!h || !g.contains(h)) return;
        var item = h.parentNode, body = $('.eb-acc-b', item), willOpen = body.hidden;
        $$('.eb-acc-i', g).forEach(function (it) {
          var b = $('.eb-acc-b', it), p = $('.eb-acc-h path', it);
          var open = it === item ? willOpen : false;
          if (b) b.hidden = !open;
          if (p) p.setAttribute('d', open ? MINUS : PLUS);
        });
      });
    });

    /* FAQ side nav */
    var fnav = $('#eb-fnav');
    if (fnav) fnav.addEventListener('click', function (e) {
      var b = e.target.closest('[data-fq]'); if (!b) return;
      $$('[data-fq]', fnav).forEach(function (x) { x.classList.toggle('eb-on', x === b); });
      var el = d.getElementById(b.getAttribute('data-fq'));
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    /* soft reveal on scroll */
    if ('IntersectionObserver' in window && !(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches)) {
      var io = new IntersectionObserver(function (ents) {
        ents.forEach(function (en) {
          if (!en.isIntersecting) return;
          var el = en.target; io.unobserve(el);
          setTimeout(function () { el.classList.add('eb-in'); }, el.__d || 0);
        });
      }, { rootMargin: '0px 0px -6% 0px', threshold: 0.08 });
      $$('.eb-main .eb-sec-h, .eb-main .eb-hscroll .eb-card, .eb-main .eb-cat, .eb-main .eb-occ, .eb-main .eb-mat, .eb-main .eb-tl-i, .eb-main .eb-bf, .eb-main .eb-feat-h, .eb-main .eb-story-g').forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight) return;
        var sib = el.parentElement ? Array.prototype.indexOf.call(el.parentElement.children, el) : 0;
        el.__d = Math.min(sib, 4) * 70;
        el.classList.add('eb-reveal');
        io.observe(el);
      });
    }
  }

  /* ---------------- collection ---------------- */
  function initCollection() {
    var wrap = $('#eb-col'); if (!wrap) return;
    var grid = $('#eb-grid'), cards = $$('.eb-card', grid), drawer = $('#eb-filters');
    var layer = $('#eb-layer');
    if (drawer && layer) layer.appendChild(drawer);
    var params = new URLSearchParams(location.search);
    var st = { col: '', mats: [], stys: [], sizes: [], pmax: null, sale: params.get('sale') === '1' };
    var STEP = 16, limit = STEP;
    var prices = cards.map(function (c) { return +c.getAttribute('data-price') / 100; });
    var pMin = prices.length ? Math.floor(Math.min.apply(null, prices) / 5) * 5 : 0;
    var pMax = prices.length ? Math.ceil(Math.max.apply(null, prices) / 5) * 5 : 0;
    var range = $('#eb-prange');
    range.min = pMin; range.max = pMax; range.value = pMax;
    $('#eb-prange-l').textContent = '£' + pMin + ' – £' + pMax;

    /* colour swatches from the products actually in this collection */
    var seen = {}, cols = [];
    cards.forEach(function (c) {
      var v = c.getAttribute('data-col'); if (!v || seen[v.toLowerCase()]) return;
      seen[v.toLowerCase()] = 1; cols.push(v);
    });
    if (cols.length < 2) $('#eb-f-col').hidden = true;
    $('#eb-f-cols').innerHTML = cols.map(function (c) {
      return '<button type="button" data-fc="' + esc(c) + '"><span class="eb-sw" style="background: ' + (HEX[c.toLowerCase()] || '#999') + '"></span>' + esc(c) + '</button>';
    }).join('');

    function match(c) {
      var col = (c.getAttribute('data-col') || '').toLowerCase();
      if (st.col && col.indexOf(st.col.toLowerCase()) < 0) return false;
      if (st.mats.length && st.mats.indexOf(c.getAttribute('data-mat')) < 0) return false;
      if (st.stys.length) { var s = c.getAttribute('data-sty') || ''; if (!st.stys.some(function (x) { return s.indexOf(x) >= 0; })) return false; }
      if (st.sizes.length) { var z = (c.getAttribute('data-sizes') || '').split(','); if (!st.sizes.some(function (x) { return z.indexOf(x) >= 0; })) return false; }
      if (st.pmax !== null && +c.getAttribute('data-price') > st.pmax * 100 + 0.5) return false;
      if (st.sale && c.getAttribute('data-sale') !== '1') return false;
      return true;
    }
    function chip(label, key, val) {
      return '<button type="button" class="eb-achip" data-rm="' + key + '" data-v="' + esc(val) + '">' + esc(label) + '<svg class="eb-ico" viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"></path></svg></button>';
    }
    function apply() {
      var ok = cards.filter(match), n = 0;
      cards.forEach(function (c) { c.hidden = true; });
      ok.forEach(function (c) { n++; c.hidden = n > limit; });
      var shown = Math.min(limit, ok.length);
      $('#eb-shown').textContent = shown;
      $('#eb-total').textContent = ok.length;
      $('#eb-pct').style.width = (ok.length ? Math.round(shown / ok.length * 100) : 100) + '%';
      $('#eb-loadmore').hidden = shown >= ok.length;
      $('#eb-fcount').textContent = ok.length;
      var chips = '';
      if (st.col) chips += chip('Colour: ' + st.col, 'col', '');
      st.mats.forEach(function (v) { chips += chip(v, 'mats', v); });
      st.stys.forEach(function (v) { chips += chip(v.charAt(0).toUpperCase() + v.slice(1), 'stys', v); });
      st.sizes.forEach(function (v) { chips += chip('EU ' + v, 'sizes', v); });
      if (st.pmax !== null && st.pmax < pMax) chips += chip('Up to £' + st.pmax, 'pmax', '');
      if (st.sale) chips += chip('On sale', 'sale', '');
      var act = $('#eb-active');
      act.hidden = !chips;
      act.innerHTML = chips ? '<span style="color: #5F584F">' + ok.length + ' results ·</span>' + chips + '<button type="button" style="text-decoration: underline; color: #5F584F" data-clear>Clear all</button>' : '';
      $$('[data-qc]').forEach(function (b) { b.classList.toggle('eb-on', (b.getAttribute('data-qc') || '') === st.col); });
      $$('[data-fc]').forEach(function (b) { b.classList.toggle('eb-on', b.getAttribute('data-fc') === st.col); });
      $$('[data-fm]').forEach(function (b) { b.classList.toggle('eb-on', st.mats.indexOf(b.getAttribute('data-fm')) >= 0); });
      $$('[data-fs]').forEach(function (b) { b.classList.toggle('eb-on', st.stys.indexOf(b.getAttribute('data-fs')) >= 0); });
      $$('[data-fz]').forEach(function (b) { b.classList.toggle('eb-on', st.sizes.indexOf(b.getAttribute('data-fz')) >= 0); });
      $('#eb-plabel').textContent = '£' + (st.pmax === null ? pMax : st.pmax);
    }
    function toggle(arr, v) { var i = arr.indexOf(v); if (i >= 0) arr.splice(i, 1); else arr.push(v); }
    function reset() { limit = STEP; }
    function clearAll() { st.col = ''; st.mats = []; st.stys = []; st.sizes = []; st.pmax = null; st.sale = false; range.value = pMax; reset(); apply(); }

    d.addEventListener('click', function (e) {
      var t = e.target;
      var b;
      if ((b = t.closest('[data-qc]'))) { st.col = b.getAttribute('data-qc'); reset(); apply(); return; }
      if ((b = t.closest('[data-fc]'))) { var v = b.getAttribute('data-fc'); st.col = st.col === v ? '' : v; reset(); apply(); return; }
      if ((b = t.closest('[data-fm]'))) { toggle(st.mats, b.getAttribute('data-fm')); reset(); apply(); return; }
      if ((b = t.closest('[data-fs]'))) { toggle(st.stys, b.getAttribute('data-fs')); reset(); apply(); return; }
      if ((b = t.closest('[data-fz]'))) { toggle(st.sizes, b.getAttribute('data-fz')); reset(); apply(); return; }
      if ((b = t.closest('[data-sort]'))) { params.set('sort_by', b.getAttribute('data-sort')); location.search = params.toString(); return; }
      if ((b = t.closest('[data-rm]'))) {
        var k = b.getAttribute('data-rm'), val = b.getAttribute('data-v');
        if (k === 'col') st.col = ''; else if (k === 'pmax') { st.pmax = null; range.value = pMax; } else if (k === 'sale') st.sale = false; else toggle(st[k], val);
        reset(); apply(); return;
      }
      if (t.closest('[data-clear]') || t.closest('#eb-fclear')) { clearAll(); return; }
      if (t.closest('[data-eb-filters]')) { drawer.hidden = false; var sh = shade(); if (sh) sh.hidden = false; lock(true); return; }
      if (t.closest('[data-eb-fclose]') || t.closest('[data-eb-close]')) { drawer.hidden = true; if (t.closest('[data-eb-fclose]')) { var s2 = shade(); if (s2) s2.hidden = true; lock(false); } }
    });
    range.addEventListener('input', function () { st.pmax = +range.value; reset(); apply(); });
    $('#eb-loadmore').addEventListener('click', function () { limit += STEP; apply(); });
    d.addEventListener('keydown', function (e) { if (e.key === 'Escape') drawer.hidden = true; });
    apply();
  }

  /* ---------------- product ---------------- */
  function initProduct() {
    var pdp = $('#eb-pdp'), dataEl = $('#eb-pdata'); if (!pdp || !dataEl) return;
    var P; try { P = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var vars = P.variants, ci = P.col, si = P.size;
    var cur = vars.filter(function (v) { return v.id === P.current; })[0] || vars[0];
    var selCol = ci >= 0 ? cur.o[ci] : null, selSize = si >= 0 ? cur.o[si] : null;
    var mySize = store.get('eb-size');
    if (si >= 0 && mySize && !new URLSearchParams(location.search).get('variant')) {
      var mine = find(selCol, String(mySize));
      if (mine && mine.a) { selSize = String(mySize); }
    }
    var picked = false;
    function find(c, s) {
      return vars.filter(function (v) { return (ci < 0 || v.o[ci] === c) && (si < 0 || v.o[si] === s); })[0] || null;
    }
    function variant() { return si >= 0 || ci >= 0 ? find(selCol, selSize) : vars[0]; }
    var atc = $('#eb-atc'), notify = $('#eb-notify'), stick = $('#eb-stick');
    function render() {
      var v = variant();
      $$('#eb-sizes .eb-sz').forEach(function (b) {
        var z = b.getAttribute('data-size'), vv = find(selCol, z), out = !vv || !vv.a;
        b.className = 'eb-sz' + (z === selSize ? ' eb-on' : '') + (out ? ' eb-out' : '');
        var uk = b.getAttribute('data-uk');
        $('span', b).innerHTML = out ? 'Sold out' : (uk && uk !== '—' ? 'UK ' + esc(uk) : '&#160;');
        b.setAttribute('aria-label', 'EU ' + z + (out ? ', sold out' : ''));
      });
      $$('[data-colv]').forEach(function (b) { b.classList.toggle('eb-off', b.getAttribute('data-colv') !== selCol); });
      var cn = $('#eb-colname'); if (cn) cn.textContent = selCol || '';
      var sn = $('#eb-sizename'); if (sn) sn.textContent = selSize || '';
      var mn = $('#eb-mine'); if (mn) mn.hidden = !(picked && selSize && String(store.get('eb-size')) === selSize);
      if (!v) { atc.hidden = true; notify.hidden = true; return; }
      $('#eb-price').textContent = money(v.p);
      var cap = $('#eb-cap');
      if (v.c > v.p) { cap.hidden = false; $('#eb-cap-v').textContent = money(v.c); $('#eb-save').textContent = 'Save ' + money(v.c - v.p); } else cap.hidden = true;
      atc.hidden = !v.a; notify.hidden = v.a;
      if (!atc.classList.contains('eb-done')) atc.textContent = 'Add to basket · ' + money(v.p);
      $$('[data-eb-oos]').forEach(function (x) { x.textContent = selSize || ''; });
      var nb = $('#eb-notify-body'); if (nb) nb.value = 'Back in stock request: ' + P.title + ' · ' + (selCol ? selCol + ' · ' : '') + 'EU ' + (selSize || '');
      $('#eb-st-meta').textContent = [selCol, selSize ? 'EU ' + selSize : ''].filter(Boolean).join(' · ');
      $('#eb-st-p').textContent = money(v.p);
      $('#eb-st-b').hidden = !v.a;
      try { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u.toString()); } catch (e) {}
    }
    pdp.addEventListener('click', function (e) {
      var b = e.target.closest('.eb-sz');
      if (b) { selSize = b.getAttribute('data-size'); picked = true; store.set('eb-size', selSize); render(); return; }
      var c = e.target.closest('[data-colv]');
      if (c) {
        selCol = c.getAttribute('data-colv');
        var v = variant() || vars.filter(function (x) { return x.o[ci] === selCol; })[0];
        if (v && v.img) { var mi = $('#eb-mg-img'); if (mi) mi.src = v.img; }
        render(); return;
      }
      var th = e.target.closest('[data-mg]');
      if (th) {
        var img = $('#eb-mg-img'); if (img) img.src = th.getAttribute('data-mg');
        $$('[data-mg]').forEach(function (x) { x.classList.toggle('eb-on', x === th); });
        var n = $('#eb-mg-n'); if (n) n.textContent = th.getAttribute('data-mgi') + ' / ' + $$('[data-mg]').length;
      }
    });
    function add(btn) {
      var v = variant(); if (!v || !v.a || !window.ebCart) return;
      btn.disabled = true;
      window.ebCart.add(v.id, 1).then(function () {
        atc.classList.add('eb-done'); atc.textContent = 'Added ✓';
        setTimeout(function () { atc.classList.remove('eb-done'); render(); }, 2500);
      }).catch(function (err) {
        alert((err && (err.description || err.message)) || 'Sorry, this size could not be added. Please try again.');
      }).then(function () { btn.disabled = false; });
    }
    atc.addEventListener('click', function () { add(atc); });
    $('#eb-st-b').addEventListener('click', function () { add($('#eb-st-b')); });
    if (stick && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (ents) {
        var e = ents[0];
        stick.hidden = !( !e.isIntersecting && e.boundingClientRect.top < 0 );
      }).observe(atc);
      var layer = $('#eb-layer'); if (layer) layer.appendChild(stick);
    }
    if (location.search.indexOf('contact_posted=true') >= 0 && notify) { notify.hidden = false; notify.scrollIntoView({ block: 'center' }); }
    render();

    /* you may also like */
    var recs = $('#eb-recs');
    if (recs) {
      fetch(root + 'recommendations/products.json?product_id=' + recs.getAttribute('data-pid') + '&limit=4&intent=related')
        .then(function (r) { return r.json(); })
        .then(function (j) {
          var ps = (j.products || []).slice(0, 4); if (!ps.length) return;
          $('#eb-recs-g').innerHTML = ps.map(cardFromJson).join('');
          recs.hidden = false;
        }).catch(function () {});
    }
    /* recently viewed */
    var seenSec = $('#eb-seen');
    if (seenSec) {
      var list = (store.get('eb-seen') || []).filter(function (p) { return p && p.u && p.u !== P.url; }).slice(0, 4);
      if (list.length) { $('#eb-seen-g').innerHTML = list.map(function (p, i) { return simpleCard(p, i + 2); }).join(''); seenSec.hidden = false; }
    }
  }

  function init() { initCommon(); initCollection(); initProduct(); }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init); else init();
})();
